<template>
    <nav class="w-full tablet-sm:w-auto flex items-center relative left-8 top-1" id="primary-nav">
        <div class="relative -top-1 flex items-center justify-end tablet-sm:hidden w-full h-20">
            <button
                type="button"
                class="relative top-0 right-8 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                @click="mobileMenuOpen = true"
            >
                <span class="sr-only">Open main menu</span>
                <Bars3Icon class="h-10 w-10 absolute text-white" aria-hidden="true" />
            </button>
        </div>
        <div class="hidden tablet-sm:block divide-y-2 divide-white relative -top-1 mr-2">
            <div id="primary-nav-top-row" class="relative flex justify-end">
                <Link
                    :href="route('home')"
                    class="py-1 pb-2 px-4 tablet-sm:pb-4 tablet-sm:px-6 nav-link justify-center rising-underline"
                    preserve-state
                    preserve-scroll
                >
                    <h5 class="text-base tablet-sm:text-lg laptop-sm:text-xl text-white leading-6">Home</h5>
                </Link>
                <Link
                    :href="route('about')"
                    class="py-1 pb-2 px-4 tablet-sm:pb-4 tablet-sm:px-6 nav-link justify-center rising-underline"
                    preserve-state
                    preserve-scroll
                >
                    <h5 class="text-base tablet-sm:text-lg laptop-sm:text-xl text-white leading-6">About</h5>
                </Link>
                <Link
                    :href="route('current-listings')"
                    class="py-1 pb-2 px-4 tablet-sm:pb-4 tablet-sm:px-6 nav-link justify-center rising-underline"
                    preserve-state
                    preserve-scroll
                >
                    <h5 class="text-base tablet-sm:text-lg laptop-sm:text-xl text-white leading-6">Current Listings</h5>
                </Link>
                <Link
                    :href="route('contact')"
                    class="py-1 pb-2 px-4 tablet-sm:pb-4 tablet-sm:px-6 nav-link justify-center rising-underline"
                    preserve-state
                    preserve-scroll
                >
                    <h5 class="text-base tablet-sm:text-lg laptop-sm:text-xl text-white leading-6">Contact</h5>
                </Link>
            </div>
            <div id="primary-nav-bottom-row" class="pt-2 tablet-sm:pt-4 relative flex justify-end">
                <Link
                    :href="route('buying')"
                    class="p-3 px-3 tablet-sm:px-5 nav-link rising-underline"
                    preserve-state
                    preserve-scroll
                >
                    <h5 class="text-base laptop-sm:text-base text-white leading-6">Buying</h5>
                </Link>
                <Link
                    :href="route('selling')"
                    class="p-3 px-3 tablet-sm:px-5 nav-link rising-underline"
                    preserve-state
                    preserve-scroll
                >
                    <h5 class="text-base laptop-sm:text-base text-white leading-6">Selling</h5>
                </Link>
                <Popover class="relative">
                    <PopoverButton
                        class="text-base laptop-sm:text-base gap-x-1 font-subtitle leading-6 text-priamry-text"
                    >
                        <span
                            class="p-3 px-3 tablet-sm:px-5 text-white nav-link rising-underline inline-flex inline-flex items-center"
                        >
                            Resources&nbsp;
                            <ChevronDownIcon class="h-4 w-4 text-white" aria-hidden="true" />
                        </span>
                    </PopoverButton>

                    <transition
                        enter-active-class="transition ease-out duration-200"
                        enter-from-class="opacity-0 translate-y-1"
                        enter-to-class="opacity-100 translate-y-0"
                        leave-active-class="transition ease-in duration-150"
                        leave-from-class="opacity-100 translate-y-0"
                        leave-to-class="opacity-0 translate-y-1"
                    >
                        <PopoverPanel
                            v-slot="{ open, close }"
                            class="absolute -left-8 tablet-lg:-left-6 z-10 flex w-screen max-w-max -translate-x-1/2 px-4"
                        >
                            <div
                                class="flex-auto overflow-hidden rounded-sm bg-primary-bg text-base leading-6 shadow-lg ring-1 ring-secondary-accent focus:ring-secondary-accent"
                            >
                                <div class="p-4">
                                    <div
                                        v-for="item in solutions"
                                        :key="item.name"
                                        class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-white"
                                    >
                                        <div
                                            class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-primary-bg group-hover:bg-accent"
                                        >
                                            <component
                                                :is="item.icon"
                                                class="h-6 w-6 text-secondary-accent group-hover:text-white"
                                                aria-hidden="true"
                                            />
                                        </div>
                                        <div>
                                            <Link
                                                :href="route(item.href)"
                                                class="text-primary-text hover:text-secondary-accent"
                                                preserve-state
                                                @click="close"
                                            >
                                                {{ item.name }}
                                                <span class="absolute inset-0" />
                                            </Link>
                                            <p class="z-50 mt-1 text-primary-text">{{ item.description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </PopoverPanel>
                    </transition>
                </Popover>
                <Popover class="relative">
                    <PopoverButton
                        class="text-base laptop-sm:text-base gap-x-1 font-subtitle leading-6 text-priamry-text"
                    >
                        <span
                            class="p-3 px-3 tablet-sm:px-5 text-white nav-link rising-underline inline-flex inline-flex items-center"
                        >
                            Tools&nbsp;
                            <ChevronDownIcon class="h-4 w-4 text-white" aria-hidden="true" />
                        </span>
                    </PopoverButton>

                    <transition
                        enter-active-class="transition ease-out duration-200"
                        enter-from-class="opacity-0 translate-y-1"
                        enter-to-class="opacity-100 translate-y-0"
                        leave-active-class="transition ease-in duration-150"
                        leave-from-class="opacity-100 translate-y-0"
                        leave-to-class="opacity-0 translate-y-1"
                    >
                        <PopoverPanel
                            v-slot="{ open, close }"
                            class="absolute -left-2  z-10 flex w-screen max-w-min -translate-x-1/2 px-4">
                            <div
                                class="w-52 shrink rounded-sm bg-primary-bg p-4 text-base leading-6 shadow-lg ring-1 ring-secondary-accent"
                            >
                                <Link
                                    v-for="item in tools"
                                    :key="item.name"
                                    :href="item.href"
                                    preserve-state
                                    @click="close"
                                    class="block p-2 text-primary-text hover:bg-white hover:text-secondary-accent"
                                >
                                    {{ item.name }}
                                </Link>
                            </div>
                        </PopoverPanel>
                    </transition>
                </Popover>
            </div>
        </div>
    </nav>
    <Dialog class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
        <div class="fixed inset-0 z-10" />
        <DialogPanel
            class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 z-50"
        >
            <div class="flex items-center justify-between">
                <a href="/" class="-m-1.5 p-1.5">
                    <span class="sr-only">GinaBetbeze.com</span>
                    <h2
                        class="text-secondary-accent text-xl font-semibold border-accent border-b-2 tablet-sm:border-none"
                    >
                        GinaBetbeze.com
                    </h2>
                </a>
                <button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-700" @click="mobileMenuOpen = false">
                    <span class="sr-only">Close menu</span>
                    <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                </button>
            </div>
            <div class="mt-6 flow-root">
                <div class="-my-6 divide-y divide-gray-500/10">
                    <div class="space-y-2 py-6 border-b-2 border-accent">
                        <Link
                            :href="route('home')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            Home
                        </Link>
                        <Link
                            :href="route('about')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            About
                        </Link>
                        <Link
                            :href="route('current-listings')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            Current Listings
                        </Link>
                        <Link
                            :href="route('mortgage-calculator')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            Mortgage Calculator
                        </Link>
                        <Link
                            :href="route('contact')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            Contact
                        </Link>
                        <Link
                            :href="route('buying')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            Buying
                        </Link>
                        <Link
                            :href="route('selling')"
                            class="font-title -mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7
                            text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            preserve-state
                            preserve-scroll
                            @click="mobileMenuOpen = false"
                        >
                            Selling
                        </Link>
                        <Disclosure as="div" class="-mx-3" v-slot="{ open }">
                            <DisclosureButton
                                class="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-lg font-title leading-7 text-primary-text hover:bg-gray-50 font-semibold ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            >
                                Resources
                                <ChevronDownIcon
                                    :class="[open ? 'rotate-180' : '', 'h-5 w-5 flex-none']"
                                    aria-hidden="true"
                                />
                            </DisclosureButton>
                            <DisclosurePanel class="mt-2 space-y-2 ml-6">
                                <DisclosureButton
                                    v-for="item in [...solutions, ...callsToAction]"
                                    :key="item.name"
                                    as="a"
                                    :href="route(item.href)"
                                    class="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-primary-text hover:bg-gray-50  ring-1 ring-inset ring-secondary-accent bg-primary-bg font-title"
                                    @click="mobileMenuOpen = false"
                                >
                                    {{ item.name }}
                                </DisclosureButton>
                            </DisclosurePanel>
                        </Disclosure>
                        <Disclosure as="div" class="-mx-3" v-slot="{ open }">
                            <DisclosureButton
                                class="font-semibold flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-lg font-title leading-7 text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg"
                            >
                                Tools
                                <ChevronDownIcon
                                    :class="[open ? 'rotate-180' : '', 'h-5 w-5 flex-none']"
                                    aria-hidden="true"
                                />
                            </DisclosureButton>
                            <DisclosurePanel class="mt-2 space-y-2 ml-6">
                                <DisclosureButton class="mt-2 space-y-2 ml-6">
                                    <Link
                                        v-for="item in [...tools, ...callsToAction]"
                                        :key="item.name"
                                        :href="item.href"
                                        preserve-state
                                        class="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-primary-text hover:bg-gray-50 ring-1 ring-inset ring-secondary-accent bg-primary-bg font-title"
                                        @click="mobileMenuOpen = false"
                                    >
                                        {{ item.name }}
                                    </Link>
                                </DisclosureButton>
                            </DisclosurePanel>
                        </Disclosure>
                    </div>
                </div>
            </div>
        </DialogPanel>
    </Dialog>
</template>
<script setup>
import { Link } from "@inertiajs/vue3";
import {
    FingerPrintIcon,
    HomeModernIcon,
    AcademicCapIcon,
    HomeIcon,
    ChevronDownIcon,
    Bars3Icon,
    XMarkIcon,
} from "@heroicons/vue/24/outline";
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverPanel,
} from "@headlessui/vue";

const props = defineProps({
    mobileMenuOpen: {
        type: Boolean,
        default: false,
    },
});

const tools = [
    { name: "Mortgage Calculator", href: '/mortgage-calculator' },
    { name: "Property Search", href: '/#property-search' },
];

const solutions = [
    {
        name: "Neighborhoods",
        description: "Explore local neighborhoods\nto find your perfect home.",
        href: "neighborhoods",
        icon: HomeModernIcon,
    },
    {
        name: "School Information",
        description: "Get details on local schools,\nincluding ratings and programs.",
        href: "school-info",
        icon: AcademicCapIcon,
    },
    {
        name: "County Appraiser & Valuation",
        description: "Access links to county appraiser offices.",
        href: "county-appraisals",
        icon: HomeIcon, // You might consider using an icon that represents property or valuation if available
    },
    {
        name: "Crime Maps",
        description: "Stay informed with up-to-date\ncrime data for your area.",
        href: "crime-maps",
        icon: FingerPrintIcon,
    },
];
const callsToAction = [];

</script>

<style scoped>
.rising-underline {
    position: relative;
    overflow: hidden;
}

.rising-underline::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5px;
    background-color: white;
    transform: translateY(100%);
    transition: transform 0.3s ease;
}

.rising-underline:hover::after {
    transform: translateY(0);
}
</style>
